import type { CreativeMedium } from "../../shared/types";

export type MediumSelection = "all" | CreativeMedium;

export function MediumFilter({ value, onChange }: { value: MediumSelection; onChange: (value: MediumSelection) => void }) {
  return <div className="medium-filter" role="group" aria-label="Creative medium">
    {([['all', 'All'], ['video', 'Videos'], ['image', 'Images']] as const).map(([medium, label]) => <button type="button" key={medium} aria-pressed={value === medium} className={value === medium ? "is-active" : ""} onClick={() => onChange(medium)}>{label}</button>)}
  </div>;
}
